import React, { useState } from 'react';
import * as EmailValidator from "email-validator";
import '../../Styles/LoginPage/Login.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faEnvelope, faLock, faUser, faImage } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

function RegisterForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confPass, setConfPass] = useState('');
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [file, setFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [confirmMessage, setConfirmMessage] = useState('');

  function handleSubmit() {
    const valid =
      EmailValidator.validate(email) &&
      /^(?=.*\d)(?=.*[a-z])(?=.*[a-zA-Z]).{6,}$/gm.test(password) &&
      name !== '' && surname !== '' && confPass === password;

    if (valid) {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('password', password);
      formData.append('fname', name);
      formData.append('lname', surname);
      formData.append('image', file);

      fetch('/api/register', { method: 'POST', body: formData })
        .then(async (res) => {
          if (res.status === 403) {
            setConfirmMessage('');
            setErrorMessage(await res.text());
          }
          if (res.status === 201) {
            setErrorMessage('');
            setConfirmMessage(await res.text());
          }
        })
        .catch(err => setErrorMessage(String(err)));
    } else {
      setConfirmMessage('');
      setErrorMessage('Les informations ne sont pas correctement renseignées');
    }
  }

  return (
    <div className="lf-root">
      <div className="lf-form">

        <div className="lf-field">
          <label htmlFor="reg-email" className="lf-field__label">Adresse e-mail</label>
          <div className="lf-field__wrap">
            <span className="lf-field__icon" aria-hidden="true"><FontAwesomeIcon icon={faEnvelope} /></span>
            <input
              type="text"
              className="lf-field__input"
              id="reg-email"
              placeholder="votre@email.com"
              autoComplete="email"
              onChange={e => setEmail(e.target.value)}
            />
          </div>
        </div>

        <div className="lf-row">
          <div className="lf-field">
            <label htmlFor="reg-surname" className="lf-field__label">Nom</label>
            <div className="lf-field__wrap">
              <span className="lf-field__icon" aria-hidden="true"><FontAwesomeIcon icon={faUser} /></span>
              <input
                type="text"
                className="lf-field__input"
                id="reg-surname"
                placeholder="Dupont"
                autoComplete="family-name"
                onChange={e => setSurname(e.target.value)}
              />
            </div>
          </div>

          <div className="lf-field">
            <label htmlFor="reg-name" className="lf-field__label">Prénom</label>
            <div className="lf-field__wrap">
              <span className="lf-field__icon" aria-hidden="true"><FontAwesomeIcon icon={faUser} /></span>
              <input
                type="text"
                className="lf-field__input"
                id="reg-name"
                placeholder="Jean"
                autoComplete="given-name"
                onChange={e => setName(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="lf-field">
          <label htmlFor="reg-password" className="lf-field__label">Mot de passe</label>
          <div className="lf-field__wrap">
            <span className="lf-field__icon" aria-hidden="true"><FontAwesomeIcon icon={faLock} /></span>
            <input
              type={showPass ? 'text' : 'password'}
              className="lf-field__input lf-field__input--pwd"
              id="reg-password"
              placeholder="Min. 6 car., lettres et chiffres"
              autoComplete="new-password"
              onChange={e => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="lf-field__toggle"
              onClick={() => setShowPass(s => !s)}
              aria-label={showPass ? 'Masquer' : 'Afficher'}
            >
              <FontAwesomeIcon icon={showPass ? faEyeSlash : faEye} />
            </button>
          </div>
        </div>

        <div className="lf-field">
          <label htmlFor="reg-confPass" className="lf-field__label">Confirmation du mot de passe</label>
          <div className="lf-field__wrap">
            <span className="lf-field__icon" aria-hidden="true"><FontAwesomeIcon icon={faLock} /></span>
            <input
              type="password"
              className="lf-field__input"
              id="reg-confPass"
              placeholder="••••••••"
              autoComplete="new-password"
              onChange={e => setConfPass(e.target.value)}
            />
          </div>
        </div>

        <div className="lf-upload">
          <span className="lf-upload__label">Photo de profil (optionnelle)</span>
          <label className="lf-upload__zone">
            <FontAwesomeIcon icon={faImage} className="lf-upload__icon" />
            <span className="lf-upload__text">
              {file ? file.name : 'Cliquez pour choisir une image'}
            </span>
            <input
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={e => setFile(e.target.files[0])}
            />
          </label>
        </div>

        <button type="button" className="lf-submit" onClick={handleSubmit}>
          Créer mon compte
        </button>

        {errorMessage && <div className="lf-error" role="alert">{errorMessage}</div>}
        {confirmMessage && <div className="lf-success">{confirmMessage}</div>}

        <p className="lf-switch">
          Déjà un compte ?{' '}
          <Link to="/login" className="lf-switch__link">Se connecter</Link>
        </p>
      </div>
    </div>
  );
}

export default RegisterForm;
